import { Platform } from 'react-native';

// Environment detection based on build configuration
// __DEV__ is true in development, false in production builds
const IS_PRODUCTION = !__DEV__;

// Production API URL - Render deployment
const PRODUCTION_URL = 'https://myfinalkey.onrender.com';

// Development configuration
const LOCAL_NETWORK_IP = '192.168.86.105';
const BACKEND_PORT = 5001;

const getApiUrl = (): string => {
  // Always use production Render backend for now (Android testing)
  // To revert: uncomment the block below and remove this line
  return PRODUCTION_URL;

  // if (IS_PRODUCTION) {
  //   return PRODUCTION_URL;
  // }
  //
  // // Development mode
  // if (Platform.OS === 'android') {
  //   // Android emulator uses 10.0.2.2 to access host machine
  //   return `http://10.0.2.2:${BACKEND_PORT}`;
  // } else {
  //   // iOS - use network IP for physical device testing
  //   return `http://${LOCAL_NETWORK_IP}:${BACKEND_PORT}`;
  // }
};

export const API_URL = getApiUrl();

export const CONFIG = {
  API_URL,
  IS_IOS: Platform.OS === 'ios',
  IS_ANDROID: Platform.OS === 'android',
  IS_PRODUCTION,
  IS_DEV: __DEV__,
}; 
